import { FbPopupCellRendererClass } from './FbPopupCellRendererClass';

/**
 * Devuelve la clase FbListCellRenderer, para que el grid la instancie cuando pinta la celda en modo edición.
 * Esta clase centraliza metodos para usar el popup del grid, renderiza en especial la directiva <fb-grid-popup>
 *
 * @param {FbCellRenderer} FbCellRenderer se pasa la clase como injección de dependencia
 * @param {Object} options opciones que se pasan de clase en clase (FbListCellRenderer -> FbCellRenderer -> EcCellRenderer)
 * @param {Object} methods metodos que se usan para personalizar la celda.
 * @param {function} methods.renderPopup debe devolver el contenido html del popup, se llama con ({value, data})
 * @returns {FbListCellRenderer}
 */

const defaultOptions = { ecCellName: 'FbListCellRenderer' };

export function FbListCellRendererClass(FbCellRenderer, options, { renderChipsFn, renderPopup } = {}) {
  const FbPopupCellRenderer = FbPopupCellRendererClass(FbCellRenderer, options, { renderPopup });

  return class FbListCellRenderer extends FbPopupCellRenderer {
    constructor(currentOptions = {}) {
      super(Object.assign({}, defaultOptions, options, currentOptions));

      if (typeof renderPopup !== 'function') {
        throw new Error('FbListCellRenderer: "popup.templateFn" obligatorio');
      }
    }

    render(params) {
      const { value: values } = params;
      if (!Array.isArray(values) || !values.length) {
        this.renderBadge('');
        return '';
      }
      this.renderBadge(values.length);

      return `&nbsp;${values.map((value, index) => renderChipsFn({ value, index, isEditable: this.isEditable })).join('&nbsp;')}`;
    }

    flash(params) {
      this.openPopup().then(() => {
        this.eCellPopup?.ePopup?.querySelector?.('ec-grid-list2')?.flash?.(params);
      });
    }
  };
}
